<template>

    <b-card title="Change Subscription">

        <p>
            To change your subscription: choose a new subscription from the list, 
            provide the requested information, and then click the Change button.
            To cancel your paid subscription, select an option from the Free Tier.
        </p>

        <p>
            Paid subscriptions automatically renew at the end of their term.
        </p>

        <b-form @submit="submitSubscriptionChange">

            <b-form-group
                id="group-subscriptionLevel"
                description=""
                label="Current Subscription Level"
                label-for="subscriptionLevel">
                
                    <b-form-input
                        id="subscriptionLevel"
                        :disabled="true"
                        :value="subscriptionName"></b-form-input>
                
            </b-form-group>
            
            <b-form-group
                id="group-newSubscriptionLevel"
                description=""
                label="New Subscription Level"
                label-for="newSubscriptionLevel"
                invalid-feedback="Please select a valid level."
                valid-feedback=""
                :state="formValidation.newSubscriptionLevel">
                
                    <b-form-select 
                        id="newSubscriptionLevel"
                        v-model="localFormData.newSubscriptionLevel" 
                        :options="validSubscriptionLevelsGrouped"
                        @change="newSubscriptionLevelSelected"/>
                
            </b-form-group>

            <b-form-group
                v-if="(localFormData.newSubscriptionTier == 'paid') && (localFormData.newSubscriptionTier != localUserData.subscriptionTier)"
                id="group-subscriptionLevel"
                description=""
                label="Payment Details"
                label-for="cardForUpdatedSubscription"
                :invalid-feedback="localFormValidation.cardMessage"
                :state="localFormValidation.cardError">
                
                    <StripeField
                        parentId="group-subscriptionLevel"
                        id="cardForUpdatedSubscription"
                        ref="cardForUpdatedSubscription"
                        @statusUpdate:StripeField="handleStripeFieldStatusUpdate"
                        @newSubscription:StripeField="handleNewStripeSubscription"/>

                <b-form-text>
                    Your payment card information (securely processed using <a href="https://www.stripe.com">Stripe</a>).
                </b-form-text>
                
            </b-form-group>


            <b-card-footer style="text-align:right">
                <b-button ref="buttonChangeSubscription" type="submit" variant="success">Change</b-button>
            </b-card-footer>
        
        </b-form>

    </b-card>

</template>

<script>

import genericOps from '@/mixins/genericOps'
import LocalStripeService from '@/services/LocalStripeService'
import StripeField from '@/components/StripeField.vue'

export default {
    name: 'ChangeSubscription',
    components: {
        StripeField
    },
    mixins: [
        genericOps
    ],
    props: {
        subscriptionDetails: {
            type: Object,
            default: {}
        },
        userData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            formData: {
                newSubscriptionTier: null,
                newSubscriptionLevel: null,
            },
            formValidation: {
                cardMessage: null,
                newSubscriptionTier: null,
                newSubscriptionLevel: null,
            },
        }
    },
    computed: {
        localFormData: {
            get: function() {
                
                return this.formData
            
            },
            set: function(newValue) {
                this.formData = newValue
            }
        },
        localFormValidation: {
            get: function() {
                
                return this.formValidation
            
            },
            set: function(newValue) {
            }
        },
        localUserData: {
            get: function() {
                
                return this.userData
            
            },
            set: function(newValue) {
            }
        },
        subscriptionName: function() {
            
            return this.getNameForSubscription(this.$store.getters.getUser.subscriptionLevel)
        }
    },
    watch: {

    },
    methods: {
        handleNewStripeSubscription(data) {

            // Add certain payment details to the store in case we
            // later want to show the user additional details.
            this.$store.commit('SET_PAYMENT_DETAILS', data.paymentDetails)
            
            // Copy data from Stripe and the form to the user and update
            // the database
            this.localUserData.stripeCustomerId = data.customerId
            this.localUserData.stripeSubscriptionId = data.subscriptionId
            this.localUserData.stripeProductId = data.productId
            this.localUserData.subscriptionLevel = this.localFormData.newSubscriptionLevel
            this.localUserData.subscriptionTier = this.localFormData.newSubscriptionTier

            // Clear out form data to prevent confusion
            this.localFormData.newSubscriptionLevel = null
            this.localFormData.newSubscriptionTier = null
            this.$refs.buttonChangeSubscription.disabled = false

            this.$emit('subscriptionUpdated:ChangeSubscription', {
                user: this.localUserData
                , message: 'Your subscription has been updated.'
            })

        },
        handleStripeFieldStatusUpdate(data) {
            
            //console.log(data)

            this.$set(this.localFormValidation, 'cardError', data.cardError)
            this.$set(this.localFormValidation, 'cardMessage', data.cardMessage)

        },
        newSubscriptionLevelSelected() {
            this.localFormData.newSubscriptionTier = this.getSubscriptionTier(this.localFormData.newSubscriptionLevel)
        },
        submitSubscriptionChange(evt) {

            evt.preventDefault()

            this.$refs.buttonChangeSubscription.disabled = true

            //console.log('SubscriptionManager.onSubscriptionChange')

            this.formValidation = {}
            this.formValidation.valid = true

            
            if(typeof this.localFormData.newSubscriptionLevel == 'undefined' || this.localFormData.newSubscriptionLevel === null) {
                
                this.formValidation.newSubscriptionLevel = false
                this.formValidation.valid = false
            
            } else {
            
                if(this.localFormData.newSubscriptionLevel == this.localUserData.subscriptionLevel) {
                    this.formValidation.newSubscriptionLevel = false
                    this.formValidation.valid = false
                }    
            
            }
            
            

            if(this.formValidation.valid) {
                
                // User is upgrading from a free subscription to a paid subscription.
                if(this.localUserData.subscriptionTier == 'free' && this.localFormData.newSubscriptionTier == 'paid') {

                    // User previously had a paid subscription
                    if(this.localUserData.stripeCustomerId) {

                        this.$refs.cardForUpdatedSubscription.createStripePaymentMethod(this.localUserData.stripeCustomerId, this.localFormData.newSubscriptionLevel)

                    // User never had a paid subscription
                    } else {
                        this.$refs.cardForUpdatedSubscription.createStripeCustomer(this.localUserData.firstName, this.localUserData.lastName, this.localUserData.email).then((result) => {
                            this.$refs.cardForUpdatedSubscription.createStripePaymentMethod(result.data.result.data.id, this.localFormData.newSubscriptionLevel)
                        })
                    }

                // User is changing from one paid subscription to another.
                } else if(this.localUserData.subscriptionTier == 'paid' && this.localFormData.newSubscriptionTier == 'paid') {
                
                    //console.log(this.$components)

                    let itemToCancel = this.subscriptionDetails.data.data.items.data[0].id

                    let updatedSubscription = {
                        cancel_at_period_end: false,
                        proration_behavior: 'create_prorations',
                        items: [{
                            id: itemToCancel,
                            price: this.localFormData.newSubscriptionLevel,
                        }]
                    }
                    
                    LocalStripeService.updateSubsciption(this.localUserData.stripeSubscriptionId, updatedSubscription, this.$store.getters.getUserToken).then((response) => {
            
                        //console.log('LocalStripeService.updateSubsciption returned '+ JSON.stringify(response))

                        if(response.data.result.successful) {

                            // Copy data from Stripe and the form to the user and update
                            // the database
                            this.localUserData.subscriptionLevel = this.localFormData.newSubscriptionLevel
                            this.localUserData.subscriptionTier = this.localFormData.newSubscriptionTier

                            // Clear out form data to prevent confusion
                            this.localFormData.newSubscriptionLevel = null
                            this.localFormData.newSubscriptionTier = null
                            this.$refs.buttonChangeSubscription.disabled = false

                            this.$emit('subscriptionUpdated:ChangeSubscription', {
                                user: this.localUserData
                                , message: 'Your subscription has been updated.'
                                , refreshSubscription: true
                            })
                        }
                        
                        return response

                    }).catch((error) => {
                        //console.log('StripeField.updateSubscription encountered an exception: ' + JSON.stringify(error))
                        this.handleStripeError(error)
                    })

                    

                // User is downgrading from a paid subscription to a free subscription.
                } else if(this.localUserData.subscriptionTier == 'paid' && this.localFormData.newSubscriptionTier == 'free') {
                    
                    let updatedSubscription = {
                        cancel_at_period_end: true
                    }
                    
                    LocalStripeService.updateSubsciption(this.localUserData.stripeSubscriptionId, updatedSubscription, this.$store.getters.getUserToken).then((response) => {

                        if(response.data.result.successful) {

                            // Don't update user tier immediately - they remain on paid tier until period end
                            // The subscription will be cancelled automatically at the end of the billing period

                            // Clear out form data to prevent confusion
                            this.localFormData.newSubscriptionLevel = null
                            this.localFormData.newSubscriptionTier = null
                            this.$refs.buttonChangeSubscription.disabled = false

                            this.$emit('subscriptionUpdated:ChangeSubscription', {
                                user: this.localUserData
                                , message: 'Your subscription will be cancelled at the end of the current billing period. You will continue to have access to premium features until then.'
                                , refreshSubscription: true
                            })
                            
                        }
                        
                        return response

                    }).catch((error) => {
                        this.handleStripeError(error)
                    })
                }

                

            } else {
                this.$refs.buttonChangeSubscription.disabled = false
            }

        },
    }

    
}
</script>

<style scoped>

</style>